/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Just_Loved_Chipmunk_DareInputs */

const fr_just_loved_chipmunk_dare = /** @type {(inputs: Just_Loved_Chipmunk_DareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune section pour le moment`)
};

/**

* @param {Just_Loved_Chipmunk_DareInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const just_loved_chipmunk_dare = /** @type {((inputs?: Just_Loved_Chipmunk_DareInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Just_Loved_Chipmunk_DareInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_just_loved_chipmunk_dare(inputs)
});